// extracted by mini-css-extract-plugin
module.exports = {"LandingMenuItems":"LandingMenuItems__LandingMenuItems___2oWOH"};